import ensureZepto from 'amkit3-modules/utils/ensure-zepto'
import { getLogger } from 'amkit3-modules/utils/log4js'

const logger = getLogger('utils/ensure-huya-ya')

let ensureTT = cb => {
  if (global.YA) {
    setTimeout(() => {
      if (process.env.NODE_ENV === 'development') {
        global.ya = {
          reportProductEvent: data => logger.debug('reportProductEvent', data),
        }
      }
      cb(null, global.YA)
    }, 0)
  } else {
    ensureZepto((_, $) => {
      $.getScript('https://static-jw.msstatic.com/rp/ya-huya.finall.min.js', () => {
        if (process.env.NODE_ENV === 'development') {
          global.ya = {
            reportProductEvent: data => logger.debug('reportProductEvent', data),
          }
        }
        cb(null, global.TT)
      })
    })
  }
}

export default ensureTT
